<template>
  <div class="bg-energetic-blue h-1 my-8"></div>
</template>

<script>
export default {
  name: "ThickRule"
}
</script>